// 🔥 HOLDINGS CALCULATION
export const calculateHoldings = (transactions, selectedPartner) => {
    const holdingsMap = {};

    const partnerId = selectedPartner?.id || "all";

    const filteredTx = transactions.filter(
        (tx) =>
            partnerId === "all" ||
            tx.partnerId === partnerId
    );

    filteredTx.forEach((tx) => {
        const scrip = tx.scrip;

        if (!holdingsMap[scrip]) {
            holdingsMap[scrip] = {
                buyQty: 0,
                sellQty: 0,
            };
        }

        if (tx.transactionType === "BUY") {
            holdingsMap[scrip].buyQty += Number(tx.quantity);
        } else {
            holdingsMap[scrip].sellQty += Number(tx.quantity);
        }
    });

    const currentStocks = {};

    Object.keys(holdingsMap).forEach((scrip) => {
        const remaining =
            holdingsMap[scrip].buyQty - holdingsMap[scrip].sellQty;

        if (remaining > 0) {
            currentStocks[scrip] = remaining;
        }
    });

    return currentStocks;
};


// 🔥 INVESTMENT CALCULATION
export const calculateInvestment = (
    transactions,
    scrip,
    selectedPartner
) => {
    let totalBuyAmount = 0;
    let totalSellAmount = 0;

    const partnerId = selectedPartner?.id || "all";

    const filteredTx = transactions.filter(
        (tx) =>
            tx.scrip === scrip &&
            (partnerId === "all" ||
                tx.partnerId === partnerId)
    );

    filteredTx.forEach((tx) => {
        if (tx.transactionType === "BUY") {
            totalBuyAmount += Number(tx.amount);
        } else {
            totalSellAmount += Number(tx.amount);
        }
    });

    return totalBuyAmount - totalSellAmount;
};


// 🔥 UPL CALCULATION (no change needed)
export const calculateUPL = (qty, ltp, investment) => {
    const sellValue = qty * ltp;
    const sellCommission = sellValue * 0.00345 + 25;
    const netSellValue = sellValue - sellCommission;

    const profit = netSellValue - investment;
    const capitalGainTax = profit > 0 ? profit * 0.075 : 0;

    return netSellValue - investment - capitalGainTax;
};